@if (cmp()) {
  <ng-container
    *ngComponentOutlet="
      cmp();
      inputs: {
        themeProps: themeProps(),
        mode: mode(),
        contentAreas: contentAreas(),
        invoicePositions: invoicePositions(),
      }
    "
  >
  </ng-container>
}
